<template>
    <div class="feature-plan-wrapper" @click="showPlans">
        <div class="feature-plan-wrapper-head">
            <WebhookIntegration />
            {{ plan.altTitle }}
        </div>
        <div class="feature-plan-wrapper-footer">
            {{ isSelected ? $t("billing.packageManagement") : $t("billing.buyNow") }}
        </div>
    </div>
</template>
<script>

import WebhookIntegration from "./svg/features/WebhookIntegration.vue";

export default {
    name: "FeaturePlan",
    components: { WebhookIntegration },
    props: {
        plan: {
            type: Object,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({}),
    methods: {
        showPlans() {
            this.$router.push(`/billing/plans/${this.plan.dynamicType}`);
        },
    },
};
</script>
<style lang="scss" scoped>
.feature-plan-wrapper {
    border-radius: 8px;
    border: 1px solid #E2E2E2;
    cursor: pointer;

    &-head {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border-bottom: 1px solid #E2E2E2;
        padding: 16px;
        text-wrap: nowrap;
        font-weight: 600;

        svg {
            width: 40px;
            height: 40px;
        }
    }

    &-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8796AF;
        padding: 10px 0px;
    }

    &:hover {
        border: 1px solid #8796AF;

        .feature-plan-wrapper-footer {
            color: #5625CC;
        }
    }
}
</style>
